import { z } from "zod";

import { PluginExclusionGroupEntitySchema_2023_08_20 } from "./2023-08-20";

export * from "./2023-08-20";

export const PluginExclusionGroupEntitySchema =
  PluginExclusionGroupEntitySchema_2023_08_20;
export type PluginExclusionGroupEntityType = z.infer<
  typeof PluginExclusionGroupEntitySchema
>;
